import React from 'react';
import { useLoaderData } from "react-router-dom";
import Question from '../Question/Question';
const SingleQuiz = () => {
    const quiz = useLoaderData().data;
    const questions = quiz.questions;
    return (
        <div>
            <h1 className='text-3xl font-bold my-6'>{quiz.name} Quiz!!</h1>
            <div className='questions-container'>
                {
                    questions.map((question, index) => <Question index={index} question={question} key={question.id}></Question>)
                }
            </div>
        </div>
    );
};

export default SingleQuiz;